export const navigation = {

    categories: [

        {
            id: 'Lifestyle',
            name: 'Lifestyle (3)',

        },
        {
            id: 'Shopping',
            name: 'Shopping (2)',

        },
        {
            id: 'Travel',
            name: 'Travel (3)',

        },
        {
            id: 'Hobies',
            name: 'Hobies (2)',

        },
        {
            id: 'Fashion',
            name: 'Fashion (1)',

        },
    ],
    blogs: [
        {
            id: 1,
            date: 'Sep 22, 2020',
            img: 'https://vertexcables.com/wp-content/uploads/2020/07/blog-9.jpg',
            name: 'Cras ornare trisbtique elit.',
            categories: ['Shopping', 'Lifestyle'],
            shortdes: 'Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh.',
            animation: 'fade-left'
        },
        {
            id: 2,
            date: 'Sep 21, 2020',
            img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcgXg4wVf_V-69Dcl7c2NdlHUC0EPfHcyeledWC6ElPi2LJZFYsZ3PQt5_A4ibISiuEsw&usqp=CAU',
            name: 'Vivamus vestibulum ntulla ne cante.',
            categories: ['Lifestyle'],
            shortdes: 'Morbi purus libero, faucibus commodo quis, gravida id, est. Vestibulumvo lutpat, lacus a ultrices sagittis...',
            animation: 'fade-up'
        },
        {
            id: 3,
            date: 'Sep 18, 2020',
            img: 'https://mailchamp.ru/wp-content/uploads/2020/09/Demo34_Blog_03.jpg',
            name: 'Utaliquam sollicitudsvin leo.',
            categories: ['Shopping', 'Lifestyle'],
            shortdes: 'Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh.',
            animation: 'fade-down'
        },
        {
            id: 4,
            date: 'Sep 22, 2020',
            img: 'https://youmatter.world/app/uploads/sites/2/2019/11/travel-world.jpg',
            name: 'Fusce pellentesvque suscipit.',
            categories: ['Travel'],
            shortdes: 'Morbi purus libero, faucibus commodo quis, gravida id, est. Vestibulumvo lutpat, lacus a ultrices sagittis...',
            animation: 'fade-right'
        },
        {
            id: 5,
            date: 'Sep 8, 2020',
            img: 'http://www.holysmithereens.com/wp-content/uploads/2019/02/The-Traveler-1024x683.jpg',
            name: 'Aenean dignissim pellente ssdvquefelis.',
            categories: ['Travel', "Hobies"],
            shortdes: 'Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh.',
            animation: 'fade-right'
        },
        {
            id: 6,
            date: 'Sep 22, 2020',
            img: 'https://blog.editors.ca/wp-content/uploads/2014/06/2423286.jpg',
            name: 'Quisque volutbsbpat mattiseros.',
            categories: ['Hobies'],
            shortdes: 'Morbi purus libero, faucibus commodo quis, gravida id, est. Vestibulumvo lutpat, lacus a ultrices sagittis...',
            animation: 'fade-down'
        },
        {
            id: 7,
            date: 'Sep 13, 2020',
            img: 'https://pushselectmagazine.com/wp-content/uploads/2020/08/Travel-Tips1.jpg',
            name: 'Utaliquam sollivscitudin leo.',
            categories: ['Travel'],
            shortdes: 'Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh.',
            animation: 'fade-up'
        },
        {
            id: 8,
            date: 'Sep 20, 2020',
            img: 'https://img.freepik.com/free-photo/pretty-young-stylish-sexy-woman-pink-luxury-dress-summer-fashion-trend-chic-style-sunglasses-blue-studio-background-shopping-holding-paper-bags-talking-mobile-phone-shopaholic_285396-2957.jpg?size=626&ext=jpg',
            name: 'Quisque a lsvsectus',
            categories: ['Fashion'],
            shortdes: 'Morbi purus libero, faucibus commodo quis, gravida id, est. Vestibulumvo lutpat, lacus a ultrices sagittis...',
            animation: 'fade-left'
        },
    ]

}

